var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { transformObject } from 'hx-util';
import { snakeCase } from 'change-case';
// const CORS_PROXY_URL =
// ensureEndsWith(process.env.REACT_APP_CORS_PROXY_URL, '/') || '';
var API_URL = process.env.REACT_APP_VIDEO_CALL_API_URL;
export var videoCallService = {
    getRoomToken: function (req) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (process.env.REACT_APP_NODE_ENV !== 'development') {
                return [2 /*return*/, getRoomTokenProd(req)];
            }
            else {
                return [2 /*return*/, getRoomTokenStaging(req)];
            }
            return [2 /*return*/];
        });
    }); },
    getIsInBusinessHours: function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    assertApiUrlExists(API_URL);
                    return [4 /*yield*/, fetch("".concat(API_URL, "/hours"))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data.data];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    error = _a.sent();
                    throw new Error(error.message);
            }
        });
    }); },
};
function assertApiUrlExists(apiUrl) {
    if (!API_URL) {
        throw new Error('REACT_VIDEO_CALL_API_URL is not set');
    }
}
var getRoomTokenProd = function (req) { return __awaiter(void 0, void 0, void 0, function () {
    var _req, _url, response, data, _data, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertApiUrlExists(API_URL);
                _req = {
                    reason: '-',
                    type: 'sales',
                    firstName: req.firstName,
                    lastName: req.lastName,
                    contactNumber: req.contactNumber,
                };
                _url = "".concat(API_URL, "/start_call");
                return [4 /*yield*/, fetch("".concat(_url), {
                        method: 'POST',
                        body: JSON.stringify(transformObject(_req, {
                            keys: snakeCase,
                        })),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                _data = __assign(__assign({}, data), { data: __assign(__assign({}, data.data), { token: data.data.room_token }) });
                return [2 /*return*/, _data];
            case 3: return [4 /*yield*/, response.json()];
            case 4:
                error = _a.sent();
                throw new Error(error.message);
        }
    });
}); };
var getRoomTokenStaging = function (req) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, response, data, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assertApiUrlExists(API_URL);
                _url = "".concat(API_URL, "/token");
                return [4 /*yield*/, fetch("".concat(_url), {
                        method: 'POST',
                        body: JSON.stringify(transformObject({
                            room: req.room,
                        }, {
                            keys: snakeCase,
                        })),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    data = response.json();
                    return [2 /*return*/, data];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                error = _a.sent();
                throw new Error(error.message);
        }
    });
}); };
